<!-- Header -->
<template>
  <div class="component-header">
    <!-- logo -->
    <router-link :to="{ path: '/' }" class="slide-item-content">
      <img src="../assets/images/logo.png" class="logo" />
    </router-link>
    <!-- 烈士纪念日 -->
    <img
      src="../assets/images/jnr.png"
      :class="{
        jnrmobile: isphone,
        jnrpc: isphone == false
      }"
    />
    <!-- 930图片 -->
    <img
      src="../assets/images/930.png"
      :class="{
        jslmobile: isphone,
        jslpc: isphone == false
      }"
    />
    <!-- Banner 开始 -->
    <img src="../assets/images/baner1.png" class="banner" />
    <!-- Banner 结束 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ComponentHeader",
  data() {
    return {
      // 导航菜单列表
      // name: 菜单名称
      // to  : 点击菜单后要跳转的路由路径
      navList: [
        { name: "首页", to: "/" },
        { name: "信息资讯", to: "/news/information-dynamics" },
        { name: "褒扬纪念政策", to: "/praise-the-commemoration-policy" },
        { name: "烈士英名录", to: "/martyr/list-of-martyrs" },
        { name: "烈士纪念设施", to: "/cemetery-directories" },
        { name: "VR数字展馆", to: "/vr" },
        { name: "网上祭扫", to: "/sacrifice" },
        { name: "远程代祭", to: "/replace" }
      ],
      isphone: false
    };
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex" // 当前激活的导航菜单的下标
    ])
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.logo {
  width: 139px;
  height: 105px;
  position: absolute;
  right: 52px;
  top: 46px;
}
.jnrpc {
  width: 331px;
  height: 60px;
  position: absolute;
  right: 788px;
  top: 375px;
  /* 手机端 */
  /* right: 419px;
  top: 216px; */
}
.jnrmobile {
  width: 331px;
  height: 60px;
  position: absolute;
  /* 手机端 */
  right: 37%;
  top: 35%;
}
.jslpc {
  width: 331px;
  height: 24px;
  position: absolute;
  right: 788px;
  top: 450px;
}
.jslmobile {
  width: 331px;
  height: 24px;
  position: absolute;
  /* 手机端 */
  right: 37%;
  top: 45%;
}
.component-header {
  position: relative;
  min-width: 1200px;
}

.banner {
  display: block;
  width: 100%;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-bottom: 58px;
}

.top {
  flex-shrink: 0;
  height: 80px;
  border-bottom: 1px solid rgba(255, 238, 205, 0.2);
}

.top .main-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .logo {
  height: 52px;
}

.top .links {
  display: flex;
  align-items: center;
}

.top .link {
  font-size: 16px;
  color: #ffffff;
  width: 75px;
  height: 38px;
  line-height: 38px;
  text-align: center;
}

.top .link-register {
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  border-radius: 10px;
  color: var(--main-color);
  font-weight: bold;
}

.mid {
  flex: 1;
}

.mid .main-content {
  height: 100%;
  display: flex;
  align-items: center;
}

.mid .web-title {
  height: 73px;
}

.navs {
  width: 100%;
  height: 58px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(109, 3, 4, 0.9);
  z-index: 20;
}

.navs .main-content {
  height: 100%;
  display: flex;
}

.navs .link {
  flex: 1;
  flex-shrink: 0;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.4s;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 16px;
  position: relative;
}

.navs .link:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
}

.navs .link::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  left: 0;
  top: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.4s;
}

.navs .link:hover {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link:hover::after {
  opacity: 1;
  transform: scale(1);
}

.navs .link.active {
  color: var(--main-color);
  font-weight: bold;
  font-size: 18px;
}

.navs .link.active::after {
  opacity: 1;
  transform: scale(1);
}

.has-login-wrapper {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.has-login-wrapper .link-mine {
  color: #f7f17d;
  font-weight: bold;
  margin-right: 16px;
}

.has-login-wrapper .userinfo {
  display: flex;
  align-items: center;
}

.has-login-wrapper .avatar {
  width: 48px;
  height: 48px;
  border: 2px solid #fbd48b;
  margin-right: 8px;
  cursor: pointer;
}

.has-login-wrapper .nickname {
  color: #ffffff;
}
.has-login-wrapper .logouts {
  color: #bb1515;
  border: solid 1px #ef7878;
  padding: 3px;
  background-color: #eae3b6;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}
.has-login-wrapper .logouts:hover {
  color: #e72c2c;
}
.has-login-wrapper .logouts:active {
  color: #9b2020;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue